// eslint-disable-next-line import/export
export * from '@/constant/api';
export * from '@/constant/storeModules';
export * from '@/constant/router';
export * from '@/constant/iconfont';
export * from '@/constant/telescope';

export const ROUTE_PATH = {
  checkout: '/checkout',
  confirm: '/confirm',
  success: '/success',
  fail: '/fail'
};


export enum EPingPayWay {
  wechatPub = 'wechat_pub',
  wechatH5 = 'wechat_h5',
  unionPayH5 = 'union_pay_h5',
  alipayH5 = 'alipay_h5'
}

export const PAY_WAY: { [prop: string]: string } = {
  alipay_app: 'aliPay', // 支付宝
  union_pay_app: 'yinLianPay', // 银联
  wechat_app: 'wxpay' // 微信
};

export enum EPayResult {
  success = 'pay_success',
  fail = 'pay_fail',
  cancel = 'pay_cancel',
  invalid = 'pay_invalid',
  ok = success,
  pay_fail = 0,
  pay_success,
  pay_invalid
}
